import React from"react";
import { Swiper, SwiperSlide } from"swiper/react";
import { Navigation, Autoplay, Pagination } from"swiper/modules";
import"swiper/css";
import"swiper/css/navigation";
import"swiper/css/pagination";
import"./About.css";
import location from"../Assests/Icons/location.png";
import phone from"../Assests/Icons/phone.png";
import email from"../Assests/Icons/email.png";
import chat from"../Assests/Icons/message.png";

const About = () => {
 const steps = [
"Sign up for an account to get started.",
"Choose a course that suits your goals.",
"Access course materials and resources.",
"Attend live sessions or watch recordings.",
"Complete assignments and quizzes.",
"Earn certification after successful completion.",
 ];

 const testimonials = [
"This is an amazing course!",
"I learned so much in just a few weeks.",
"The instructors are very knowledgeable.",
"A great platform for skill development.",
"Highly recommended for beginners and pros alike.",
 ];

 // Corresponding icons (can repeat for now)
 const stepIcons = [location, phone, email, chat, location, phone];

 return (
 <div className="bg-bgMain text-body min-h-screen">
 {/* Image on Top */}
 <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden">
 <img
 src="https://www.shutterstock.com/image-photo/email-concept-person-working-laptop-600nw-2267870761.jpg"
 alt="About Us"
 className="w-full h-full object-cover brightness-50"
 />
 <div className="absolute inset-0 bg-gradient-to-b from-transparent to-bgMain"></div>
 <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4">
 <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter drop-shadow-md">
 Who We Are
 </h1>
 <p className="text-white/90 text-lg md:text-xl mt-4 max-w-2xl font-semibold">
 Empowering the next generation of coders through AI-driven learning and real-world skill mastery.
 </p>
 </div>
 </div>

 {/* Courses Offered Section */}
 <section className="py-20 px-6 md:px-12 bg-bgSoft text-heading">
 <div className="max-w-7xl mx-auto">
 <h2 className="text-3xl md:text-5xl font-black mb-12 text-center text-heading">
 <span className="text-primary text-enterprise-title">Courses</span> Offered
 </h2>
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
 {[
 "Web Technologies",
 "Databases",
 "Cloud Computing",
 "Programming Languages",
 ].map((course, index) => (
 <div key={index} className="flex bg-white rounded-2xl shadow-md overflow-hidden group hover:scale-[1.02] transition-transform border border-accentGray/20">
 <div className="flex-1 bg-brand-gradient p-6 flex items-center justify-center text-white text-center">
 <h3 className="font-bold text-lg">{course}</h3>
 </div>
 <div className="w-20 bg-bgSoft flex items-center justify-center text-muted font-bold text-3xl group-hover:text-primary transition-colors">
 {index + 1}
 </div>
 </div>
 ))}
 </div>
 </div>
 </section>

 {/* How it Works Section */}
 <section className="py-24 px-6 md:px-12 bg-bgMain text-body">
 <div className="max-w-7xl mx-auto">
 <h2 className="text-3xl md:text-5xl font-bold mb-16 text-center">
 How It <span className="text-primary">Works</span>
 </h2>
 <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
 {steps.map((desc, index) => (
 <div key={index} className="flex flex-col items-center text-center group">
 <div className="relative w-24 h-24 mb-6">
 <div className="absolute inset-0 bg-brand-gradient rounded-full blur-md opacity-20 group-hover:opacity-40 transition-opacity"></div>
 <div className="relative w-full h-full rounded-full border-2 border-primary/20 bg-white flex items-center justify-center overflow-hidden shadow-soft">
 <img
 src={stepIcons[index]}
 alt={`Step ${index + 1}`}
 className="w-10 h-10 object-contain grayscale group-hover:grayscale-0 transition-all"
 />
 <div className="absolute -bottom-1 right-2 bg-primary text-white w-7 h-7 rounded-full text-xs font-bold flex items-center justify-center border-2 border-white shadow-sm">
 {index + 1}
 </div>
 </div>
 </div>
 <p className="text-muted text-sm leading-relaxed group-hover:text-body transition-colors">{desc}</p>
 </div>
 ))}
 </div>
 </div>
 </section>

 {/* Brief Intro of Us */}
 <section className="py-24 px-6 md:px-12 bg-bgSoft text-heading">
 <div className="max-w-5xl mx-auto text-center">
 <h2 className="text-3xl md:text-5xl font-bold mb-6">Brief Intro of Us</h2>
 <p className="text-muted text-xl mb-16">
 Explore our features and offerings at a glance
 </p>
 
 <div className="flex flex-wrap justify-center gap-12 relative">
 <div className="w-48 h-48 rounded-full bg-brand-gradient flex items-center justify-center text-white font-black text-3xl shadow-hero relative z-10 border-4 border-white">
 SkillGenie
 </div>
 
 {/* Features circle simulation */}
 <div className="grid grid-cols-2 md:grid-cols-3 gap-8 w-full mt-12">
 <FeatureCircle label="Users" value="29+" />
 <FeatureCircle label="Institutions" value="Global" />
 <FeatureCircle label="Courses" value="90+" />
 <FeatureCircle label="Certifications" value="QR Verified" />
 <FeatureCircle label="Quizzes" value="Real-time" />
 <FeatureCircle label="Community" value="Active" />
 </div>
 </div>
 </div>
 </section>

 {/* Testimonials Section */}
 <section className="py-24 px-6 md:px-12 bg-bgMain text-body border-t border-accentGray/30">
 <div className="max-w-4xl mx-auto text-center">
 <h2 className="text-3xl md:text-5xl font-bold mb-16">What Our <span className="text-primary">Students Say</span></h2>
 <Swiper
 modules={[Navigation, Autoplay, Pagination]}
 spaceBetween={50}
 slidesPerView={1}
 loop={true}
 autoplay={{ delay: 3500, disableOnInteraction: false }}
 pagination={{ clickable: true }}
 className="pb-12"
 >
 {testimonials.map((text, index) => (
 <SwiperSlide key={index}>
 <div className="bg-bgSection p-10 rounded-3xl border border-primary/20 shadow-2xl">
 <p className="text-xl md:text-2xl italic leading-relaxed text-body">"{text}"</p>
 <h4 className="mt-8 text-primary font-bold">— Student Graduate</h4>
 </div>
 </SwiperSlide>
 ))}
 </Swiper>
 </div>
 </section>
 </div>
 );
};

const FeatureCircle = ({ label, value }) => (
 <div className="flex flex-col items-center justify-center bg-white p-6 rounded-2xl shadow-lg border-b-4 border-primary">
 <div className="text-primary font-extrabold text-2xl mb-1">{value}</div>
 <div className="text-muted font-bold uppercase tracking-widest text-xs">{label}</div>
 </div>
);

export default About;



